import React from 'react';
import './HeroTestimonialSection.css';
import { FaQuoteLeft } from 'react-icons/fa';
import backgroundImage from '../../assets/images/dummy_meeting2.jpg'; // Adjust path as needed

export default function HeroTestimonialSection() {
  return (
    <section
      className="hero-section_tt1"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="hero-overlay_tt1"></div>
      <div className="hero-content_tt1">
        <FaQuoteLeft className="hero-icon_tt1" />
        <h1 className="hero-title_tt1">Building Trust Through Excellence</h1>
        <p className="hero-description_tt1">
          At Saars India Liaison Pvt Ltd, client satisfaction is at the core of
          everything we do. Discover how our tailored consulting services and
          dedication to excellence have helped businesses achieve their goals
          with confidence.
        </p>  
      </div>
    </section>
  );
}
